// Shared by the server rules (server/creatorCodes.ts) and the web/mobile
// copy that quotes them.

/** How long after signup an account can still enter a creator code. */
export const CREATOR_CODE_WINDOW_DAYS = 30;

export const CREATOR_CODE_SURFACES = [
  "signup_survey",
  "upgrade_modal",
  "mobile_profile",
] as const;

export type CreatorCodeSurface = (typeof CREATOR_CODE_SURFACES)[number];
